import { styled } from '@linaria/react';

import { COLORS_MAP, type CommonProps } from '../constants';

export const SIZES = [undefined, 'L', 'M', 'S'] as const;
export type TSize = (typeof SIZES)[number];

const FONT_SIZES = {
	S: '2.0rem',
	M: '2.4rem',
	L: '2.8rem',
};

const LINE_HEIGHTS = {
	S: '2.8rem',
	M: '3.0rem',
	L: '3.6rem',
};

export const Title = styled.p<CommonProps<TSize>>`
	color: ${({ color }) => (color ? COLORS_MAP[color] : 'inherit')};
	font-size: ${({ size = 'M' }) => FONT_SIZES[size]};
	font-weight: var(--font-weight-medium);
	line-height: ${({ size = 'M' }) => LINE_HEIGHTS[size]};

	text-align: ${({ align }) => align ?? 'center'};
	text-transform: ${({ transform }) => transform ?? 'inherit'};
	text-wrap: balance;
	white-space: ${({ multiline }) => (multiline ? 'pre-wrap' : 'inherit')};
	word-break: ${({ multiline }) => (multiline ? 'break-word' : 'inherit')};
	&::first-letter {
		text-transform: ${({ capitalizeFirstLetter }) =>
			capitalizeFirstLetter ? 'uppercase' : 'inherit'};
	}
`;
